var FcCustomBadgeComponent = /** @class */ (function () {
    function FcCustomBadgeComponent() {
    }
    return FcCustomBadgeComponent;
}());
export { FcCustomBadgeComponent };
